export const IS_DEV = process.env.NODE_ENV === 'development'
export const IS_PRODUCTION = process.env.NODE_ENV === 'production'

export const IS_CYPRESS = typeof window !== 'undefined' && !!(window as unknown as { Cypress: unknown }).Cypress
